import {SetChangePassword} from './thunk/setChangePassword';
import {SetCreateGroup} from './thunk/setCreateGroup';
import {SetCreateUser} from './thunk/setCreateUser';
import {SetGroups} from './thunk/setGroups';
import {SetPostBlock} from './thunk/setPostBlock';
import {SetPostChangeLetter} from './thunk/setPostChangeLetter';
import {SetPostHide} from './thunk/setPostHide';
import {SetPostWager} from './thunk/setPostWager';
import {SetUsers} from './thunk/setUsers';

export const Thunks = {
    SetChangePassword,
    SetCreateGroup,
    SetCreateUser,
    SetGroups,
    SetPostBlock,
    SetPostChangeLetter,
    SetPostHide,
    SetPostWager,
    SetUsers
}